import { createAction } from '@reduxjs/toolkit';
const prefix = `elevio/aiResponse`;
export const aiResponseActions = {
    aiResponseRequested: createAction(`${prefix}/aiResponseChanged`),
    aiResponseReceived: createAction(`${prefix}/aiResponseReceived`),
    aiResponseError: createAction(`${prefix}/aiResponseError`),
    aiResponseFinally: createAction(`${prefix}/aiResponseFinally`),
    updateReplySectionTabStatus: createAction(`${prefix}/updateReplySectionTabStatus`),
};
